import { MetaSettingsForm } from '@/routes/trackings/destinations/meta/meta-settings';
import { MetaProductSettingsTab } from '@/routes/trackings/destinations/meta/meta-product-settings';
import { TransactionsFilteringForm } from '@/routes/trackings/components/transactions-filtering-form';
import DownloadMetaGtmContainer from '@/routes/trackings/destinations/meta/meta-download-gtm';
import { useNavigate, useParams } from 'react-router-dom';
import { useCallback, useMemo, useState } from 'react';
import {
  createSetupNavigator,
  DestinationTrackingDetails
} from '../../components/destination-tracking-details';

export const MetaTrackingDetails = ({
  isPublishable,
  isSetup
}: {
  isPublishable: boolean;
  isSetup: boolean;
}) => {
  const navigate = useNavigate();
  const { tab: tabFromParams = 'integration', id } = useParams<{ tab: string; id: string }>();

  const [displayTabs, setDisplayTabs] = useState([
    {
      label: 'Meta Settings',
      value: 'integration',
      disabled: false,
      setupCompleted: false
    },
    {
      label: 'Product Settings',
      value: 'product-settings',
      disabled: true,
      setupCompleted: false
    },
    {
      label: 'Transactions',
      value: 'transactions',
      disabled: true,
      setupCompleted: false
    },
    {
      label: 'GTM Container',
      value: 'gtm-container',
      disabled: true,
      setupCompleted: false,
      isPublishable: isPublishable
    }
  ]);

  const [activeTab, setActiveTab] = useState(tabFromParams || displayTabs[0].value);

  const handleTabChange = useCallback(
    (newTabValue: string) => {
      setActiveTab(newTabValue);
      void navigate(`../integrations/${id!}/${newTabValue}`, { replace: true, state: { isSetup } });
    },
    [navigate, id, isSetup, setActiveTab]
  );

  const navigateToNextStep = useMemo(
    () =>
      createSetupNavigator(
        () => displayTabs,
        () => activeTab,
        setDisplayTabs,
        handleTabChange
      ),
    [displayTabs, activeTab, handleTabChange]
  );

  const handleNonSetupContinue = useCallback(() => {
    // TODO: FIX LOGIC SO EMPTY FUNCTION IS NOT NEEDED
  }, []);

  const onContinue = isSetup ? navigateToNextStep : handleNonSetupContinue;

  const content = [
    {
      key: 'integration',
      content: <MetaSettingsForm onContinue={onContinue} />
    },
    {
      key: 'product-settings',
      content: <MetaProductSettingsTab isSetup={isSetup} onContinue={onContinue} />
    },
    {
      key: 'transactions',
      content: (
        <TransactionsFilteringForm isLastTab={false} onContinue={onContinue} isSetup={isSetup} />
      )
    },
    { key: 'gtm-container', content: <DownloadMetaGtmContainer /> }
  ];

  return (
    <>
      <DestinationTrackingDetails
        displayTabs={displayTabs}
        isSetup={isSetup}
        activeTab={activeTab}
        onTabChange={handleTabChange}
        id={id!}
        content={content}
      />
    </>
  );
};
